import React from "react"
import EditAddPerson from "../PersonalLoan/EditAddPerson";


const EditPersonLoan = () =>{
    return(
        <EditAddPerson editPersonLoan officeLoan />
    )
};
export default EditPersonLoan;